import type { NavigationGuardNext, RouteLocationNormalized } from "vue-router";

import { useAuthStore } from "@/domains/auth/store/auth.store";

export function authGuard(
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
): void {
  const auth = useAuthStore();

  if (to.meta["requiresAuth"] && !auth.isAuthenticated) {
    next({ name: "Login" });

    return;
  }

  if (to.meta["guestOnly"] && auth.isAuthenticated) {
    next({ name: "Users" });

    return;
  }

  if (to.meta["superAdminOnly"] && !auth.isSuperAdmin) {
    next({ name: "Users" });

    return;
  }

  const permission = to.meta["permission"];

  if (permission && !auth.can(permission)) {
    next({ name: "Users" });

    return;
  }

  next();
}
